import { produce } from 'immer'
import {
  GET_MONTHLY_SPEND_SUCCESS,
  GetMonthlySpendActions,
} from 'src/app/Home/redux/home.actions'
import { DailySpendDataResponse } from 'src/models/dailySpendData.models'

export interface MonthlySpendState {
  listResponses: DailySpendDataResponse[]
}

export const initialState: MonthlySpendState = {
  listResponses: [],
}

export type Actions = GetMonthlySpendActions

const MonthlySpendReducer = (
  state: MonthlySpendState = initialState,
  action: Actions,
): MonthlySpendState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_MONTHLY_SPEND_SUCCESS: {
        draft.listResponses = action.payload.chartData.dailySpendData.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.date]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }
    }
  })
}

export default MonthlySpendReducer
